import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Truncates an ISO datetime/date string to `yyyy-MM-dd` for `<input type="date">` and date-only API fields. */
export function toDateInputValue(value?: string): string {
  return value ? value.slice(0, 10) : ''
}
